export default function BrandLogo({ className = "", title = "SpørgMig" }) {
  return (
    <img
      src="/sporgmig-logo.png"
      alt={title}
      className={`h-7 max-w-full w-auto object-contain sm:h-8 ${className}`.trim()}
    />
  );
}
